<template>
	<div class="centerWidth">
		<div class="gaokao">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>查:职业查询</span>
			</div>

			<div class="bai_zhi">
				<hgroup>
					<h6>职业名称</h6>
					<p>{{ details.TypeName }}</p>
				</hgroup>
				<ul>
					<li>
						<h6>
							<i></i>
							职业定义
						</h6>
						<div class="li_txt">{{ details.Define  }}</div>
					</li>
					<li>
						<h6>
							<i></i>
							任务职责
						</h6>
						<h5>
							<span>•</span>工作内容、任务、职责
						</h5>
						<div class="li_txt">{{ details.Content  }}</div>
						<h5>
							<span>•</span>工作考核邀请
						</h5>
						<div class="li_txt">{{ details.Requirment   }}</div>
					</li>
					<li>
						<h6>
							<i></i>
							知识背景
						</h6>
						<h5>
							<span>•</span>学历要求
						</h5>
						<div class="li_txt">{{ details.Education }}</div>
						<h5>
							<span>•</span>行业知识背景
						</h5>
						<div class="li_txt">{{ details.IndustryBackground }}</div>
						<h5>
							<span>•</span>专业知识背景
						</h5>
						<div class="li_txt">{{ details.SpecialBackground }}</div>
					</li>
					<li>
						<h6>
							<i></i>
							发展前景
						</h6>
						<h5>
							<span>•</span>行业发展前景
						</h5>
						<div class="li_txt">{{ details.IndustryDevelopment }}</div>
						<h5>
							<span>•</span>个人发展路径
						</h5>
						<div class="li_txt">{{ details.PersonDevelopment }}</div>
						<h5>
							<span>•</span>职业的就业趋势
						</h5>
						<div class="li_txt">{{ details.EmploymentTrend }}</div>
					</li>
					<li>
						<h6>
							<i></i>
							薪酬待遇
						</h6>
						<h5>
							<span>•</span>薪酬结构
						</h5>
						<div class="li_txt">{{ details.SalaryStructure }}</div>
						<h5>
							<span>•</span>满意度
						</h5>
						<div class="li_txt">{{ details.Satisfaction }}</div>
						<h5>
							<span>•</span>福利制度
						</h5>
						<div class="li_txt">{{ details.Welfare }}</div>
					</li>
					<li>
						<h6>
							<i></i>
							职业道德
						</h6>
						<div class="li_txt">{{ details.ProfessionalEthic }}</div>
					</li>
					<li>
						<h6>
							<i></i>
							常用工具
						</h6>
						<div class="li_txt">{{ details.CommonTool }}</div>
					</li>
					<li>
						<h6>
							<i></i>
							从业资格
						</h6>
						<div class="li_txt">{{ details.OccupationalRequirement }}</div>
					</li>
					<li>
						<h6>
							<i></i>
							大学课程
						</h6>
						<div class="li_txt">{{ details.UniversityCourse }}</div>
					</li>
					<li>
						<h6>
							<i></i>
							工作环节
						</h6>
						<div class="li_txt">{{ details.WorkEnvironment }}</div>
					</li>
					<li>
						<h6>
							<i></i>
							职业技能
						</h6>
						<div class="li_txt">{{ details.VocationalSkills }}</div>
					</li>
				</ul>
			</div>

			<!-- <section class="flex float xqTop">
				<article class="xqLeft">
					<h1>{{ name }}</h1>
					<ul>
						<li v-for="(item, index) in leftList" :key="index" :class="pid == item.Id ? 'on' : ''" @click="leftClick(item.Id)">{{ item.TypeName }}</li>
					</ul>
				</article>
				<article class="xqRight">
					<ul>
						<li v-for="(item, index) in rightList" :key="index">
							<h6>{{ item.Occupation }}</h6>
							<p>{{ item.Infor }}</p>
						</li>
					</ul>
					<div class="flex xend major-page">
						<el-pagination background layout="prev, pager, next" :page-size="size" @current-change="GetPageList" :current-page="page" :total="totleNum"></el-pagination>
					</div>
				</article>
			</section> -->
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: 0,
				name: '',
				pid: 0,
				page: 1,
				size: 10,
				totleNum: 0,
				leftList: [],
				rightList: [],
				details: {}
			};
		},
		// 加载
		mounted() {
			this.id = this.$route.query.id;
			// this.name = this.$route.query.name;
			// this.pid = this.$route.query.pid;

			// this.GetOccupationTypeByPid();
			// this.OccupationInquiryInforList(1);
			this.getDetail();
		},
		methods: {
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},
			getDetail() {
				const that = this;
				that.$api.HttpGet('SystemData/NewOccupationInquiryDetail', {
					id: that.id
				}, function(res) {
					if (res.code === 0) {
						console.log('ok', res);
						that.details = res.data;
					}
				}, function(err) {
					console.log(err);
				});
			},
			GetOccupationTypeByPid() {
				var that = this;

				that.$api.HtppRequest(
					'SystemData/GetOccupationTypeByPid?pid=' + that.id,
					'GET', {},
					function(res) {
						console.log('获取列表', res);

						if (res.flag) {
							that.leftList = res.list;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 获取列表
			OccupationInquiryInforList: function(page) {
				var that = this;

				that.$api.HtppRequest(
					'SystemData/OccupationInquiryInforList?page=' + page + '&size=10&tid=' + this.pid,
					'GET', {},
					function(res) {
						console.log('获取列表2');
						console.log(res);
						if (res.flag) {
							var list = res.list;
							that.totleNum = res.totle;
							if (page === 1) {
								that.rightList = [];
							}
							if (list.length > 0) {
								that.page = page;
								for (var i = 0; i < list.length; i++) {
									that.rightList.push(list[i]);
								}
							}
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			leftClick(index) {
				this.pid = index;
				this.OccupationInquiryInforList(1);
			},
			// 获取其他页
			GetPageList: function(val) {
				var that = this;
				that.OccupationInquiryInforList(val);
			}
		}
	};
</script>

<style scoped>
	.li_txt {
		margin-top: 10px;
		padding-left: 15px;
		font-size: 14px;
		color: #666;
	}

	.bai_zhi li h6 i {
		width: 4px;
		height: 20px;
		background-color: #005371;
		display: inline-block;
		margin-right: 14px;
	}

	.bai_zhi li h6 {
		font-size: 16px;
		color: #000;
		font-weight: normal;
		display: flex;
		align-items: center;
	}

	.bai_zhi li {
		padding-top: 30px;
	}

	.bai_zhi hgroup p {
		font-size: 14px;
		color: #333;
		margin-top: 15px;
	}

	.bai_zhi hgroup h6 {
		font-size: 16px;
		color: #000;
	}

	.bai_zhi hgroup {
		padding: 30px 20px;
		background-color: #eaeaea;
	}

	.bai_zhi {
		background-color: #fff;
		padding: 19px;
	}

	/* bai_zhi */

	.xqRight li p {
		margin-top: 15px;
		font-size: 14px;
		color: #666;
		margin-left: 15px;
		line-height: 26px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.xqRight li h6 {
		font-size: 14px;
		padding-left: 15px;
		border-left: solid 4px #333;
	}

	.xqRight li {
		margin-top: 20px;
	}

	.xqRight li:first-child {
		margin-top: 0;
	}

	.xqRight ul {
		overflow: hidden;
		padding: 20px;
	}

	.xqRight {
		overflow: hidden;
		width: calc(100% - 260px);
		background-color: #fff;
	}

	/* xqRight */

	.xqLeft ul {
		overflow: hidden;
	}

	.xqLeft li.on {
		background-color: #ccdde3;
	}

	.xqLeft li {
		font-size: 14px;
		color: #333;
		text-indent: 20px;
		height: 60px;
		line-height: 60px;
		cursor: pointer;
		border-bottom: solid 1px #e6e6e6;
	}

	.xqLeft h1 {
		background-color: #333;
		height: 60px;
		color: #fff;
		font-weight: normal;
		font-size: 20px;
		line-height: 60px;
		text-indent: 20px;
	}

	.xqLeft {
		width: 240px;
		height: auto;
		min-height: 520px;
		background-color: #fff;
	}

	.xqTop {
		overflow: hidden;
	}

	/* xqTop */

	.gaokao {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	.widthWhite {
		padding-bottom: 60px;
	}

	.xqTop {
		padding-bottom: 60px;
	}

	/* 001 */

	.bai_zhi h5 span {
		margin-right: 10px;
	}

	.bai_zhi h5 {
		font-weight: normal;
		font-size: 14px;
		padding: 20px 0 0 0;
	}
</style>
